import { create } from 'zustand';
import { getUmbracoApiUser } from '@shared/integrations/umbraco-taf-api/features/v1/v1.ts';
import { IBaseIdentityModel } from '@shared/integrations/taf-api/v2/models';
import { createComputed } from 'zustand-computed';
import { AxiosError } from 'axios';

type ComputedApplicationStore = {
    isAuthenticated: boolean;
};

const computed = createComputed(
    (state: ApplicationStore): ComputedApplicationStore => ({
        isAuthenticated: state.user !== undefined,
    }),
);

export type ApplicationStore = {
    isDegraded?: boolean;
    backDoorEnabled?: boolean;
    setIsDegraded: (value?: boolean) => void;
    useBackDoor: () => void;
    initApp: () => void;
    cleanUp: () => void;
    user?: IBaseIdentityModel;
    authenticationError?: AxiosError;
    setAuthenticationError: (error?: AxiosError) => void;
    tryGetUser: () => Promise<void>;
};

const useApplicationStore = create<ApplicationStore>()(
    computed((set, get) => ({
        setIsDegraded: (value?) => set({ isDegraded: value }),
        useBackDoor: () => set({ backDoorEnabled: true }),
        initApp: async () => {
            await get().tryGetUser();
        },
        tryGetUser: async () => {
            await getUmbracoApiUser().then((user) => {
                if (!user || !user.firstName) return;
                set({ user: user });
            });
        },
        cleanUp: () => {
            set({ user: undefined });
        },
        setAuthenticationError: (error?: AxiosError) => set({ authenticationError: error }),
    })),
);

export default useApplicationStore;
